/**
 * @author：
 * @update：
 * @description：
 **/
import {admins, role, subscriber} from "../../api/url"
import treeDataModel from "../../components/treeDataModel/index.vue"
import {Message} from "element-ui";
export default {
    components:{
        'tree-model':treeDataModel
    },
    data() {
        return {
            isOpen:true,
            isSealing:true,
            searchasd:'',
            phoneNumber:null,
            subName:'',
            contentData: [],//列表数据
            multipleSelection: [],
            page:1,//页数
            size:10,
            count:100,//总条数
            loading: false,//加载loading

            //添加管理员
            addUserBol:false,
            defaultProps2: {
                children: 'children',
                label: 'label'
            },
            treeLoading: false,
            filterText:'',//搜索框输入内容
            addAllUserBol:false,//是否显示多选框
            allUserIndeterminate:false,//是否半选
            userCheckAll:false,//是否全选
            //树状图数据
            allUserData:[],
            originalAuthority:[],//原本权限
            selectCheckData:[],//已选中权限
            modifyPermissions:'',//要修改的权限id
            jurisdictionAllDel:[],//批量删除的权限
            jurisdictionAllDel2:[],//删除全选时的所有权限

            //角色管理
            interfaceBol:false,
            //树状图数据
            treeData:[],
            checkDataes:[],//原本权限
            checkData:[],//已选中权限
            interfaceId:'',//要修改的权限id
            jurisdictionDel:[],//批量删除的权限
            jurisdictionDel2:[],//删除全选时的所有权限

            //查看接口权限
            seeInterfaceBol:false,
            seeInterfaceData:[],

            //查看访问权限
            seeVisitBol:false,
            seeVisitData:[],

            deleteBol:false,

            resourceName:'',
            bol1:true,
            bol2:false,
        };
    },
    // 自定义方法
    methods: {
        //搜索
        searchBtn(){
            this.page=1;
            this.adminList();
        },
        //搜索重置
        searchReset(){
            this.subName='';
            this.phoneNumber='';
            this.searchBtn()
        },
        //管理员列表
        adminList(){
            this.loading = true;
            let data = {
                name:this.subName,
                userMobile:this.phoneNumber,
                pageNumber:this.page,
                pageSize:this.size
            };
            this.$ajax.get(admins,data).then((res)=>{
                console.log(res);
                this.loading = false;
                this.contentData = res.data.rows;
                this.count = res.data.total;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(val)
        },
        //分页器
        currentChange(page){
            this.page = page;
            this.contentData=[];
            this.adminList();
        },
        //我的手机号验证
        myPhone(val){
            this.phoneNumber=val.replace(/\D/g,'')
        },

        //移除管理员
        delAdmin(){
            if(this.multipleSelection.length==0) {
                this.$message({
                    showClose: true,
                    message: '至少选择一条要删除的数据',
                    type: 'error',
                    center: true,
                    duration: 3000
                });
            }else{
                this.deleteBol = true;
            }
        },
        dataListDel(){
            let data = [];
            for(let i = 0; i < this.multipleSelection.length; i++){
                data.push(this.multipleSelection[i].id)
            }
            this.$ajax.delete(admins,data).then((res)=>{
                console.log(res);
                this.deleteBol=false;
                this.adminList();
                this.$message({
                    showClose: true,
                    message: "删除成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                });
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        //添加管理员
        addAdmin(){
            //左侧全部权限
            let data = {
                pageNumber:1,
                pageSize:99999
            };
            this.treeLoading = true;
            this.$ajax.get(subscriber,data).then((res)=>{
                console.log(res);
                // let data = [];
                for(let i = 0; i <res.data.rows.length; i++){
                    // let obj = {};
                    res.data.rows[i].label = res.data.rows[i].mobile;
                    res.data.rows[i].id = res.data.rows[i].id;
                    // data.push(obj);
                    if(res.data.rows[i].profile==undefined){
                        res.data.rows[i].profile = {sex:'',nickname:'',userType:''}
                    }else{
                        if(res.data.rows[i].profile.sex=="X"){
                            res.data.rows[i].sex2 = "男"
                        }else if(res.data.rows[i].profile.sex=="M"){
                            res.data.rows[i].sex2 = "女"
                        }else{
                            res.data.rows[i].sex2 = "-"
                        }
                        if(res.data.rows[i].userType=="PERSONAL"){
                            res.data.rows[i].userType2 = "个人用户"
                        }else{
                            res.data.rows[i].userType2 = "企业用户"
                        }
                    }
                }
                this.allUserData = res.data.rows;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            }).finally(()=>{
                this.treeLoading = false;
            });
            this.addUserBol=true;
        },
        //选择框
        selectChecked(value){
            let checkedCount = value.length;
            this.userCheckAll=checkedCount === this.jurisdictionAllDel2.length;
            this.allUserIndeterminate=checkedCount > 0 && checkedCount < this.jurisdictionAllDel2.length;
        },
        //左侧用户选择
        leftSelectCheck(data, checked, indeterminate){
            this.selectCheckData = this.$refs.tree.getCheckedKeys(true);
            let dataCon = [];
            for(let i = 0; i < this.allUserData.length; i++){
                for(let j = 0; j < this.selectCheckData.length; j++){
                    if(this.allUserData[i].id==this.selectCheckData[j]){
                        dataCon.push(this.allUserData[i]);
                    }
                }
            }
            this.originalAuthority = dataCon;
        },
        // 已选择的用户列表点击删除
        delList1(id){
            this.selectCheckData.splice(this.selectCheckData.findIndex(item => item.id === id), 1);
            this.originalAuthority.splice(this.originalAuthority.findIndex(item => item.id === id), 1);
            this.$refs.tree.setChecked(id,false,false);
        },
        //已选择用户列表全选
        userAllChange(val){
            this.jurisdictionAllDel = val ? this.jurisdictionAllDel2 : [];
            this.allUserIndeterminate = false;
        },
        //关闭权限框
        addUserClose(){
            this.selectCheckData=[];
            this.originalAuthority=[];
            this.jurisdictionAllDel=[];
            this.addUserBol=false;
        },
        //提交
        addUserBtn(){
            let data = [];
            for(let i = 0; i < this.selectCheckData.length; i++){
                let obj = {};
                obj.type = 1;
                obj.userId = this.selectCheckData[i];
                data.push(obj)
            }
            this.$ajax.post(admins+'/addMore',data).then((res)=>{
                console.log(res);
                this.addUserBol = false;
                this.adminList();
                this.selectCheckData=[];
                this.originalAuthority=[];
                this.jurisdictionAllDel=[];
                this.addAllUserBol = false;
                this.$message({
                    showClose: true,
                    message: "添加成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                })
            },(err)=>{
                console.log(err);
                let messageId = err.data.split('=')[1].split(']')[0];
                let messageName = '';
                for(let i = 0; i < this.allUserData.length; i++){
                    if(this.allUserData[i].id==messageId){
                        messageName = this.allUserData[i].label
                    }
                }
                this.$message({
                    showClose: true,
                    message: messageName+'已是管理员',
                    type: 'error',
                    center: true,
                    duration: 3000
                })
            });
        },
        //右侧选择的用户删除
        userListDel(){
            let data = this.jurisdictionAllDel;
            for(let i = 0; i < this.jurisdictionAllDel.length; i++){
                this.$refs.tree.setChecked(this.jurisdictionAllDel[i],false,false);
            };
            this.jurisdictionAllDel=[];
            this.addAllUserBol = false;
        },
        //清空
        empty2(){
            this.selectCheckData=[];
            this.originalAuthority=[];
            this.jurisdictionAllDel=[];
        },
        //接口权限批量移除
        userDelBtn(){
            for(let i = 0; i < this.originalAuthority.length; i++){
                this.jurisdictionAllDel2.push(this.originalAuthority[i].id);
            }
            this.addAllUserBol = true;
        },

        //角色管理
        jurisdiction(id,name){
            this.interfaceId = id;
            this.resourceName = name;
            new Promise((resolve,reject)=> {
                //左侧全部角色
                let data = {
                    enabled:true,
                    pageNumber:1,
                    pageSize:999
                };
                this.$ajax.get(role,data).then((res)=>{
                    console.log(res);
                    let data = [];
                    for(let i = 0; i <res.data.rows.length; i++){
                        let obj = {};
                        obj.label = res.data.rows[i].name;
                        obj.id = res.data.rows[i].id;
                        obj.description =  res.data.rows[i].description;
                        data.push(obj);
                    }
                    this.treeData = data;
                    resolve('success');
                },(err)=>{
                    console.log(err);
                    reject('error');
                    if(err.status === 403){
                        this.$message({
                            showClose: true,
                            message: '当前账号没有权限',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 500) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }else if (err.status === 502) {
                        this.$message({
                            showClose: true,
                            message: '服务器异常',
                            type: 'error',
                            center: true,
                            duration: 3000
                        })
                    }
                });
            }).then((res)=>{
                return new Promise((resolve,reject)=> {
                    //右侧已有的角色
                    this.$ajax.get(admins + '/' + id).then((res) => {
                        console.log(res);
                        console.log(res.data.user.roles.length);
                        let data = [];
                        for (let i = 0; i < res.data.user.roles.length; i++) {
                            let obj = {};
                            obj.label = res.data.user.roles[i].name;
                            obj.id = res.data.user.roles[i].id;
                            obj.description = res.data.user.roles[i].description;
                            data.push(obj);
                        }
                        this.checkDataes = data;
                        resolve('success');
                    }, (err) => {
                        console.log(err);
                        reject('error');
                        if(err.status === 403){
                            this.$message({
                                showClose: true,
                                message: '当前账号没有权限',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }else if (err.status === 500) {
                            this.$message({
                                showClose: true,
                                message: '服务器异常',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }else if (err.status === 502) {
                            this.$message({
                                showClose: true,
                                message: '服务器异常',
                                type: 'error',
                                center: true,
                                duration: 3000
                            })
                        }
                    });
                })
            }).then((res)=>{
                this.jurisdictionDel2=[];
                this.interfaceBol=true;
            });
        },
        //左侧权限选择
        handleCheckChange(data){
            this.checkData = data
        },
        // 接口权限列表点击删除
        delList(id){
            this.checkData.splice(this.checkData.findIndex(item => item.id === id), 1);
            this.checkDataes.splice(this.checkDataes.findIndex(item => item.id === id), 1);
        },
        handleCheckAllChange(data){
            this.jurisdictionDel = data.jurisdictionDel;
            // this.isIndeterminate = data.isIndeterminate;
        },
        //关闭权限框
        modelClose(){
            this.interfaceBol=false;
        },
        //提交
        interfaceBtn(){
            let dataId = [];
            for(let i = 0; i < this.checkDataes.length; i++){
                dataId.push(this.checkDataes[i].id)
            }
            let data = [...this.checkData,...dataId];
            console.log(data);
            this.$ajax.post(admins+'/'+this.interfaceId+'/roles',data).then((res)=>{
                console.log(res);
                this.$message({
                    showClose: true,
                    message: "修改成功",
                    type: 'success',
                    center: true,
                    duration: 3000
                });
                this.interfaceBol = false;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        //接口删除
        delMoreList(data){
            this.$ajax.delete(admins+'/'+this.interfaceId+'/roles',data).then((res)=>{
                console.log(res);
                this.interfaceBol = false;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            })
        },
        //清空
        empty(){
            this.checkData=[];
            this.checkDataes=[];
        },

        //关闭接口权限
        interfaceClose(){
            this.seeInterfaceBol = false;
        },
        //查看接口权限
        seeInterface(id){
            this.$ajax.get(admins+'/'+id+'/authorities',{id:id}).then((res)=>{
                console.log(res);
                this.seeInterfaceData = res.data;
                this.seeInterfaceBol = true;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            });
        },

        //关闭访问权限
        visitClose(){
            this.seeVisitBol = false;
        },
        //查看访问权限
        seeVisit(id){
            this.$ajax.get(admins+'/'+id+'/accesses',{id:id}).then((res)=>{
                console.log(res);
                this.seeVisitData = res.data;
                this.seeVisitBol = true;
            },(err)=>{
                console.log(err);
                if(err.status === 403){
                    this.$message({
                        showClose: true,
                        message: '当前账号没有权限',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 500) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }else if (err.status === 502) {
                    this.$message({
                        showClose: true,
                        message: '服务器异常',
                        type: 'error',
                        center: true,
                        duration: 3000
                    })
                }
            });
        },
        //树状图过滤搜索函数
        filterNode(value, data) {
            if (!value) return true;
            if(data.profile===undefined){
                return true;
            }
            return data.mobile.indexOf(value) !== -1;
        },

    },
    // 数据观察监听
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {
        this.adminList()
    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
